var data = [
    {

        name: "Alabama",

        id: 0,
        src: "/media/Flag_of_Alabama.png",
        countryCode: "US",
        isoCode: "AL",
        latitude: "32.31823140",
        longitude: "-86.90229800",
        pop: "4.903 Million",
        area: "135,765 km²"
    },
    {

        id: 1,

        countryCode: "US",
        isoCode: "AK",
        latitude: "64.20084130",
        longitude: "-149.49367330",
        name: "Alaska", src: "/media/Flag_of_Alaska.png",
        pop: "4.731,545",
        area: "1.718 million km²"
    },
    {
        id: 2,

        countryCode: "US",
        isoCode: "Samoa",
        latitude: "-14.27097200",
        longitude: "-170.13221700",
        name: "Samoa",
        src: "/media/Samoa.png",
        pop: "55,312",
        area: "199 km²",
    },
    {
        id: 3,

        isoCode: "AZ", countryCode: "US", latitude: "34.04892810",
        longitude: "-111.09373110",
        name: "Arizona",
        src: "/media/Flag_of_Arizona.png",
        pop: "7.279 Million", area: "295,254 km²",
    },
    {
        name: "Arkansas",

        id: 4,
        isoCode: "AR",
        countryCode: "US",
        latitude: "35.20105000",
        longitude: "-91.83183340",
        src: "/media/Flag_of_Arkansas.png", pop: "3.018 Million", area: "137,733 km²",
    },
    {
        name: "Baker",
        src: "/media/Baker.gif",

        id: 5,
        isoCode: "Baker",
        countryCode: "US",
        latitude: "0.19362660",
        longitude: "-176.47690800", pop: "0", area: "2.1 km²",
    },
    {
        name: "California",

        id: 6,
        isoCode: "CA",
        countryCode: "US",
        latitude: "36.77826100",
        longitude: "-119.41793240",
        src: "/media/Flag_of_California.png", pop: "39.51 Million", area: "423,970 km²",
    },
    {
        name: "Colorado",

        id: 7,
        isoCode: "CO",
        countryCode: "US",
        latitude: "39.55005070",
        longitude: "-105.78206740",
        src: "/media/Flag_of_Colorado.png", pop: "5.759 Million", area: "269,837 km²",
    },
    {
        name: "Connecticut",

        id: 8,
        isoCode: "CT",
        countryCode: "US",
        latitude: "41.60322070",
        longitude: "-73.08774900",
        src: "/media/Flag_of_Connecticut.png", pop: "3.565 Million", area: "14,357 km²",
    },
    {
        name: "Delaware",

        id: 9,
        isoCode: "DE",
        countryCode: "US",
        latitude: "38.91083250",
        longitude: "-75.52766990",
        src: "/media/Flag_of_Delaware.png", pop: "973,764", area: "6,446 km²",
    },
    {
        name: "District of Columbia",
        src: "/media/dc.jpg",

        id: 10,
        isoCode: "DC",
        countryCode: "US",
        latitude: "38.90719230",
        longitude: "-77.03687070", pop: "692,683", area: "177 km²",
    },
    {
        name: "Florida",

        id: 11,
        isoCode: "FL",
        countryCode: "US",
        latitude: "27.66482740",
        longitude: "-81.51575350",
        src: "/media/Flag_of_Florida.png", pop: "21.48 Million", area: "170,312 km²",
    },
    {
        name: "Georgia",

        id: 12,
        isoCode: "GA",
        countryCode: "US",
        latitude: "32.16562210",
        longitude: "-82.90007510",
        src: "/media/Flag_of_Georgia.png", pop: "10.62 Million", area: "153,909 km²",
    },
    {
        name: "Hawaii",

        id: 13,
        isoCode: "HI",
        countryCode: "US",
        latitude: "19.89676620",
        longitude: "-155.58278180",
        src: "/media/Flag_of_Hawaii.png", pop: "1.416 Million", area: "28,311 km²",
    },
    {
        name: "Guam",
        src: "/media/guam.png",

        id: 14,
        isoCode: "GU",
        countryCode: "US",
        latitude: "13.44430400",
        longitude: "144.79373100", pop: "167,294 Million", area: "549 km²",
    },
    {
        name: "Howland",
        isoCode: "Howland",
        countryCode: "US",
        latitude: "0.81132190",
        longitude: "-176.61827360",
        src: "/media/howland.png", pop: "0", area: "1.6 km²",
    },
    {
        name: "Idaho",

        id: 16,
        isoCode: "ID",
        countryCode: "US",
        latitude: "44.06820190",
        longitude: "-114.74204080",
        src: "/media/Flag_of_Idaho.png", pop: "1.787 Million", area: "216,632 km²",
    },
    {
        name: "Illinois",

        id: 17,
        isoCode: "IL",
        countryCode: "US",
        latitude: "40.63312490",
        longitude: "-89.39852830",
        src: "/media/Flag_of_Illinois.png", pop: "12.67 Million", area: "149,998 km²",
    },
    {
        name: "Indiana",

        id: 18,
        isoCode: "IN",
        countryCode: "US",
        latitude: "40.26719410",
        longitude: "-86.13490190",
        src: "/media/Flag_of_Indiana.png", pop: "6.732 Million", area: "94,321 km²",
    },
    {
        name: "Iowa",

        id: 19,
        isoCode: "IA",
        countryCode: "US",
        latitude: "41.87800250",
        longitude: "-93.09770200",
        src: "/media/Flag_of_Iowa.png", pop: "3.155 Million", area: "145,743 km²",
    },
    {
        name: "Jarvis",

        id: 20,
        isoCode: "Jarvis",
        countryCode: "US",
        latitude: "-0.37435030",
        longitude: "-159.99672060",
        src: "/media/jerv.png", pop: "0", area: "4.5 km²",
    },
    {
        name: "Johnston Atoll",

        id: 21,
        isoCode: "Johnston Atoll",
        countryCode: "US",
        latitude: "16.72950350",
        longitude: "-169.53364770",
        src: "/media/JohnstonAtoll.png", pop: "0", area: "2.67 km²",
    },
    {
        name: "Kansas",

        id: 22,
        isoCode: "KS",
        countryCode: "US",
        latitude: "39.01190200",
        longitude: "-98.48424650",
        src: "/media/Flag_of_Kansas.png", pop: "2.913 Million", area: "213,096 km²",
    },
    {
        name: "Kentucky",

        id: 23,
        isoCode: "KY",
        countryCode: "US",
        latitude: "37.83933320",
        longitude: "-84.27001790",
        src: "/media/Flag_of_Kentucky.png", pop: "4.468 Million", area: "104,659 km²",
    },
    {
        name: "Kingman Reef",

        id: 24,
        isoCode: "Kingman Reef",
        countryCode: "US",
        latitude: "6.38333300",
        longitude: "-162.41666700",
        src: "/media/kngmn.gif", pop: "0", area: "0.03 km²",
    },
    {
        name: "Louisiana",

        id: 25,
        isoCode: "LA",
        countryCode: "US",
        latitude: "30.98429770",
        longitude: "-91.96233270",
        src: "/media/Flag_of_Louisiana.png", pop: "4.649 Million", area: "135,658 km²",
    },
    {
        name: "Maine",

        id: 26,
        isoCode: "ME",
        countryCode: "US",
        latitude: "45.25378300",
        longitude: "-69.44546890",
        src: "/media/Flag_of_Maine.png", pop: "1.344 Million", area: "91,646 km²",
    },
   
    {
        name: "Maryland",

        id: 27,
        isoCode: "MD",
        countryCode: "US",
        latitude: "39.04575490",
        longitude: "-76.64127120",
        src: "/media/Flag_of_Maryland.png", pop: "6.046 Million", area: "32,133 km²",
    },
    {
        name: "Massachusetts",

        id: 28,
        isoCode: "MA",
        countryCode: "US",
        latitude: "42.40721070",
        longitude: "-71.38243740",
        src: "/media/Flag_of_Massachusetts.png", pop: "6.893 Million", area: "27,363 km²",
    },
    {
        name: "Michigan",

        id: 29,
        isoCode: "MI",
        countryCode: "US",
        latitude: "44.31484430",
        longitude: "-85.60236430",
        src: "/media/Flag_of_Michigan.png", pop: "9.987 Million", area: "250,493 km²",
    },
    {
        name: "Midway Atoll",

        id: 30,
        isoCode: "Midway Atoll",
        countryCode: "US",
        latitude: "28.20721680",
        longitude: "-177.37349260",
        src: "/media/midway.png", pop: "40", area: "66.3 km²",
    },
    {
        name: "Minnesota",

        id: 31,
        isoCode: "MN",
        countryCode: "US",
        latitude: "46.72955300",
        longitude: "-94.68589980",
        src: "/media/Flag_of_Minnesota.png", pop: "5.64 Million", area: "225,181 km²",
    },
    {
        name: "Mississippi",

        id: 32,
        isoCode: "MS",
        countryCode: "US",
        latitude: "32.35466790",
        longitude: "-89.39852830",
        src: "/media/Flag_of_Mississippi.png", pop: "2.976 Million", area: "125,433 km²",
    },
    {
        name: "Missouri",

        id: 33,
        isoCode: "MO",
        countryCode: "US",
        latitude: "37.96425290",
        longitude: "-91.83183340",
        src: "/media/Flag_of_Missouri.png", pop: "6.137 Million", area: "180,533 km²",
    },
    {
        name: "Montana",

        id: 34,
        isoCode: "MT",
        countryCode: "US",
        latitude: "46.87968220",
        longitude: "-110.36256580",
        src: "/media/Flag_of_Montana.png", pop: "1.069 Million", area: "380,832 km²",
    },
    {
        name: "Navassa",

        id: 35,
        isoCode: "Navassa",
        countryCode: "US",
        latitude: "18.41006890",
        longitude: "-75.01146120",
        src: "/media/Navassa.png", pop: "0", area: "5.2 km²",
    },
    {
        name: "Nebraska",

        id: 36,
        isoCode: "NE",
        countryCode: "US",
        latitude: "41.49253740",
        longitude: "-99.90181310",
        src: "/media/Flag_of_Nebraska.png", pop: "1.934 Million", area: "200,520 km²",
    },
    {
        name: "Nevada",

        id: 37,
        isoCode: "NV",
        countryCode: "US",
        latitude: "38.80260970",
        longitude: "-116.41938900",
        src: "/media/Flag_of_Nevada.png", pop: "3.08 Million", area: "286,367 km²",
    },
    {
        name: "Hampshire",
        src: "/media/Flag_of_New_Hampshire.png",

        id: 38,
        isoCode: "NH",
        countryCode: "US",
        latitude: "43.19385160",
        longitude: "-71.57239530", pop: "1.376 Million", area: "3,769 km²",
    },
    {
        name: "New Jersey",

        id: 39,
        isoCode: "NJ",
        countryCode: "US",
        latitude: "40.05832380",
        longitude: "-74.40566120",
        src: "/media/Flag_of_New_Jersey.png", pop: "8.882 Million", area: "22,608 km²",
    },
    {
        name: "New Mexico",

        id: 40,
        isoCode: "NM",
        countryCode: "US",
        latitude: "34.51994020",
        longitude: "-105.87009010",
        src: "/media/Flag_of_New_Mexico.png", pop: "2.097 Million", area: "315,194 km²",
    },
    {
        name: "New York",

        id: 41,
        isoCode: "NY",
        countryCode: "US",
        latitude: "40.71277530",
        longitude: "-74.00597280",
        src: "/media/Flag_of_New_York.png", pop: "8.419 Million", area: "783.8 km²",
    },
    {
        name: "North Carolina",

        id: 42,
        isoCode: "NC",
        countryCode: "US",
        latitude: "35.75957310",
        longitude: "-79.01929970",
        src: "/media/Flag_of_North_Carolina.png", pop: "10.49 Million", area: "139,390 km²",
    },
    {
        name: "North Dakota",

        id: 43,
        isoCode: "ND",
        countryCode: "US",
        latitude: "47.55149260",
        longitude: "-101.00201190",
        src: "/media/Flag_of_North_Dakota.png", pop: "762,062", area: "183,272 km²",
    },
    {
        name: "Marianna",

        id: 44,
        isoCode: "MP",
        countryCode: "US",
        latitude: "15.09790000",
        longitude: "145.67390000",
        src: "/media/Mariana.png", pop: "57,216", area: "477 km²",
    },
    {
        name: "Ohio",

        id: 45,
        isoCode: "OH",
        countryCode: "US",
        latitude: "40.41728710",
        longitude: "-82.90712300",
        src: "/media/Flag_of_Ohio.png", pop: "11.69 Million", area: "116,096 km²",
    },
    {
        name: "Oklahoma",

        id: 46,
        isoCode: "OK",
        countryCode: "US",
        latitude: "35.46756020",
        longitude: "-97.51642760",
        src: "/media/Flag_of_Oklahoma.png", pop: "643,692", area: "1,608 km²",
    },
    {
        name: "Oregon",

        id: 47,
        isoCode: "OR",
        countryCode: "US",
        latitude: "43.80413340",
        longitude: "-120.55420120",
        src: "/media/Flag_of_Oregon.png",
        src: "/media/Flag_of_Oregon_(reverse).png", pop: "4.218 Million", area: "255,026 km²",
    },
    {
        name: "Palmyra Atoll",

        id: 48,
        isoCode: "Palmyra Atoll",
        countryCode: "US",
        latitude: "5.88850260",
        longitude: "-162.07866560",
        src: "/media/Palmyra.png", pop: "0", area: "10 meter (30 feet)",
    },
    {
        name: "Pennsylvania",

        id: 49,
        isoCode: "PA",
        countryCode: "US",
        latitude: "41.20332160",
        longitude: "-77.19452470",
        src: "/media/Flag_of_Pennsylvania.png", pop: "12.8 Million", area: "119,283 km²",
    },{
        name: "Wyoming",

        id: 50,
        isoCode: "WY",
        countryCode: "US",
        latitude: "43.07596780",
        longitude: "-107.29028390",
        src: "/media/Flag_of_Wyoming.png", pop: "578,759", area: "253,348 km²",
    },
    {
        name: "Rhode",
        src: "/media/Flag_of_Rhode_Island.png",

        id: 51,
        isoCode: "RI",
        countryCode: "US",
        latitude: "41.58009450",
        longitude: "-71.47742910", pop: "1.059 Million", area: "3,144 km²",
    },
    {
        name: "South Carolina",

        id: 52,
        isoCode: "SC",
        countryCode: "US",
        latitude: "33.83608100",
        longitude: "-81.16372450",
        src: "/media/Flag_of_South_Carolina.png", 
        pop: "5.149 Million", area: "82,931 km²",
    },
    {
        name: "South Dakota",

        id: 53,
        isoCode: "SD",
        countryCode: "US",
        latitude: "43.96951480",
        longitude: "-99.90181310",
        src: "/media/Flag_of_South_Dakota.png", pop: "884,659", area: "199,905 km²",
    },
    {
        name: "Tennessee",

        id: 54,
        isoCode: "TN",
        countryCode: "US",
        latitude: "35.51749130",
        longitude: "-86.58044730",
        src: "/media/Flag_of_Tennessee.png", pop: "6.829 Million", area: "109,247 km²",
    },
    {
        name: "Texas",

        id: 55,
        isoCode: "TX",
        countryCode: "US",
        latitude: "31.96859880",
        longitude: "-99.90181310",
        src: "/media/Flag_of_Texas.png", pop: "29 Million", area: "695,662 km²",
    },
    {
        name: "Minor",

        id: 56,
        isoCode: "Minor",
        countryCode: "US",
        latitude: "19.28231920",
        longitude: "166.64704700",
        src: "/media/MiOutly.png", pop: "300", area: "34.2 km²",
    },
    {
        name: "Virgin",

        id: 57,
        isoCode: "VI",
        countryCode: "US",
        latitude: "18.33576500",
        longitude: "-64.89633500",
        src: "/media/StatesVirginIands.png", pop: "106,631 ", area: "346.4 km²",
    },
    {
        name: "Utah",

        id: 58,
        isoCode: "UT",
        countryCode: "US",
        latitude: "39.32098010",
        longitude: "-111.09373110",
        src: "/media/Flag_of_Utah.png", pop: "3.206 Million", area: "219,887 km²",
    },
    {
        name: "Vermont",

        id: 59,
        isoCode: "VT",
        countryCode: "US",
        latitude: "44.55880280",
        longitude: "-72.57784150",
        src: "/media/Flag_of_Vermont.png", pop: "623,989", area: "24,923 km²",
    },
    {
        name: "Wake",

        id: 60,
        isoCode: "Wake",
        countryCode: "US",
        latitude: "19.27961900",
        longitude: "166.64993480",
        src: "/media/umwake.gif", pop: "150", area: "7.4 km²",
    },
    {
        name: "Virginia",

        id: 61,
        isoCode: "VA",
        countryCode: "US",
        latitude: "37.43157340",
        longitude: "-78.65689420",
        src: "/media/Flag_of_Virginia.png", pop: "8.536 Million", area: "110,786 km²",
    },
    {
        name: "Washington",

        id: 62,
        isoCode: "WA",
        countryCode: "US",
        latitude: "47.75107410",
        longitude: "-120.74013850",
        src: "/media/Flag_of_Washington.png", pop: "7.615 Million", area: "184,827 km²",
    },
    {
        name: "West Virginia",

        id: 63,
        isoCode: "WV",
        countryCode: "US",
        latitude: "38.59762620",
        longitude: "-80.45490260",
        src: "/media/Flag_of_West_Virginia.png", pop: "1.792 Million", area: "62,259 km²",
    },
    {
        name: "Wisconsin",

        id: 64,
        isoCode: "WI",
        countryCode: "US",
        latitude: "43.78443970",
        longitude: "-88.78786780",
        src: "/media/Flag_of_Wisconsin.png", pop: "5.822 Million", area: "169,639 km²",
    },
    
]
export default data